import React, { useEffect, useState } from 'react';
import PostFormData from './PostFormData';
import { useDispatch } from 'react-redux';
import { updatePostAction } from '../../../module/action/Post';
import pause from '../../../Assets/Images/pause.png';
import PlayIcon from '../../../Assets/Icons/PlayIcon';
import EditIcon from '../../../Assets/Icons/EditIcon';
import { assetURL } from '../../../api/utils';
import { lineBreak } from '../../../module/ConstantFunctions';
import { RichTextPreviewer } from '../../../core/components/RichTextPreviewer';
import { DEFAULT_POST_CONTENT } from '../utils/constants';

function FormPost({ data, postNumber, getBookPostData }) {
  const dispatch = useDispatch();
  const [editState, setEditState] = useState(false);
  const [audioName, setAudioName] = useState('');
  const [played, setPlayed] = useState(false);
  const [postObj, setPostObj] = useState({
    reference: '',
    post_number: '',
    content: DEFAULT_POST_CONTENT,
    recitation_audio: '',
  });
  const playSound = () => {
    new Audio(`${assetURL}${data.recitation_audio}`).play();
  };

  function playAudio() {
    if (postObj.recitation_audio || postObj.recitation_audio_url) {
      setPlayed(true);
      var x = document.getElementById(`${postNumber}-audio`);
      x.play();
    }
  }

  function pauseAudio() {
    if (postObj.recitation_audio || postObj.recitation_audio_url) {
      setPlayed(false);
      var x = document.getElementById(`${postNumber}-audio`);
      x.pause();
    }
  }

  const clearState = () => {
    setEditState(false);
    setAudioName('');
  };
  const updatePost = setConfirmLoader => {
    let obj = {
      ...postObj,
      status: data.status,
      book: data.book,
      volume: data.volume,
      main_categorie: data.main_categorie,
      categorie: data.categorie,
      sub_categorie: data.sub_categorie,
    };
    dispatch(
      updatePostAction(
        obj,
        data._id,
        clearState,
        'post',
        false,
        setConfirmLoader,
        data.book,
        data.volume,
        data.main_categorie,
        data.categorie,
        data.sub_categorie,
        data.addsub_categorie,
        false,
        false,
        false
      )
    );
  };

  const edit = () => {
    setPostObj({
      reference: data.reference,
      post_number: data.post_number,
      content: data.content,
      recitation_audio: '',
    });
    setEditState({
      reference: data.reference,
      post_number: data.post_number,
      content: data.content,
      recitation_audio: data.recitation_audio,
    });
    setAudioName(data.recitation_audio);
  };

  return !editState ? (
    <span className="" key={postNumber}>
      <h4 className="text-2xl font-extrabold mt-4">Post {postNumber}</h4>
      <div className="postDetailInner f px-8 bg-[#eef2f0] rounded-s-lg  mt-[12px] py-6 w-full">
        <div className="flex items-center justify-between w-full md:flex-row flex-col-reverse">
          <div className="flex items-center justify-between md:w-[35%] w-full">
            <div className="postRef">
              <div className="references">
                <p className="text-sm text-black font-semibold">Reference</p>

                <p dir="ltr" className="urduText font-bold text-[#0e3a1f] text-[24px] mt-1">
                  {data.reference}
                </p>
              </div>
            </div>
            <div className="postNumber">
              <div className="Number">
                <p className="text-sm text-black font-semibold">Post Number</p>

                <p
                  dir="ltr"
                  className="urduText font-bold text-[#0e3a1f] text-[24px] mt-1"
                  style={{ textAlign: 'left' }}>
                  {data.post_number}
                </p>
              </div>
            </div>
          </div>
          <button
            className="md:w-[115px] w-full text-white bg-white  flex items-center justify-center h-[48px] px-4 rounded-xl md:mb-0 mb-2"
            onClick={() => {
              edit();
            }}>
            <EditIcon width={26} height={24} fill="#000" />
          </button>
        </div>
        <div className="bg-[#DEEAE1] px-4 py-3 mt-8 rounded-xl">
          <p className="font-semibold">Post Text</p>
        </div>

        <RichTextPreviewer content={data.content} />

        <p className="font-semibold mb-[16px] mt-8">Recitation</p>
        <audio id={`${postNumber}-audio`}>
          <source
            src={data.recitation_audio_url ? data.recitation_audio_url : `${assetURL}${data.recitation_audio}`}
            type="audio/mp3"
          />
          <source
            src={data.recitation_audio_url ? data.recitation_audio_url : `${assetURL}${data.recitation_audio}`}
            type="audio/mp3"
          />
          Your browser does not support the audio element.
        </audio>

        <div className="flex items-center w-[calc(100%-40px)]">
          {played ? (
            <button
              className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
              onClick={pauseAudio}>
              <img className="h-[30%]" src={pause} />
            </button>
          ) : (
            <button
              className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
              onClick={playAudio}>
              <PlayIcon />
            </button>
          )}
          <p className="mx-[8px]  font-semibold  text-text-ellipsis w-[calc(100%-40px)]">{data.recitation_audio}</p>
          {/* <button className="bg-[#ca3030] w-[40px] h-[40px] rounded-full flex items-center justify-center">
            <DeleteIcon pathProp={{ fill: '#fff' }} />
          </button> */}
        </div>
      </div>
    </span>
  ) : (
    <PostFormData
      postObj={postObj}
      setPostObj={setPostObj}
      isPostLoading={false}
      audioName={audioName}
      setAudioName={setAudioName}
      getBookPostData={getBookPostData}
      formFunction={updatePost}
      key={postNumber}
      editState={editState}
      postNumber={postNumber}
    />
  );
}

export default FormPost;
